import { Flow_0_0_2 } from '@flexus/core';

export const BUI_44: Flow_0_0_2 = {
	id: '44',
	name: 'all_jobs_cancelled',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: '--'
		},
		viewRoles: {
			0: '--'
		}
	},
	startNode: '',
	nodes: {}
};
